/**
 * View component for /user/reset-password/:hex
 *
 * Reached from a reset password link within an email.  Checks mactch.params.hex
 * against the reset hex for that user in the database.  If valid, allows the
 * user to reach the reset-password form.  If not, displays "invalid" message
 */

// import form components
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import actions
import * as userActions from '../userActions';

// import global components
import AlertModal from '../../../global/components/modals/AlertModal.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";

// import form components
import { NewPasswordInput } from '../../../global/components/forms';

// import user components
import UserLoginLayout from '../components/UserLoginLayout.js.jsx';

class ResetPassword extends Base {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: ''
      , isErrorModalOpen: false
      , password: ""
      , submitting: false
    };
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
      , '_toggleErrorModal'
    );
  }

  componentDidMount() {
    const { dispatch, history, match } = this.props;
    dispatch(userActions.sendCheckResetHex(match.params.hex)).then(action => {
      if(action.success) {
        if(!action.onboarded) {
          history.replace(`/user/on-boarding/${match.params.hex}`);
        }
      } else {
        console.log("something wrong");
      }
    });
  }

  _handleFormChange(e) {
    let nextState = this.state;
    nextState[e.target.name] = e.target.value;
    this.setState(nextState);
  }

  _handleFormSubmit(e) {
    e.preventDefault();
    const { dispatch, history, match } = this.props;
    this.setState({submitting: true});
    dispatch(userActions.sendResetPassword(match.params.hex, this.state.password)).then((action) =>{
      this.setState({submitting: false});
      if(action.success) {
        history.push('/user/login');
      } else {
        this.setState({errorMessage: action.error});
        this._toggleErrorModal();
      }
    });
  }

  _toggleErrorModal() {
    this.setState({isErrorModalOpen: !this.state.isErrorModalOpen});
  }

  render() {
    const { user } = this.props;
    const { password , submitting} = this.state;
    let isDisabled = !password;
    return  (
      <UserLoginLayout>
        <Helmet
          title={"Reset Password | Pro-ficiency"}
        />
        <div className="yt-container user-login-container">
          <div className="yt-row center-horiz space-around">
            <div className="yt-col full s_40 m_33 l_30">
              { user.isFetching ?
                <h3>Loading...</h3>
                :
                <div>
                  { user.resetTokenValid ?
                    <form name="passwordResetForm" className="user-login-form" onSubmit={this._handleFormSubmit}>
                      <img className="-partner-logo" src="/img/logo-pd0.png" />
                      <h1 className="-form-header"> New password</h1>
                      <p className="-form-sub-header">Your password must contain at least 8 characters and one each of: uppercase, lowercase, number, and special character.</p>
                      <hr/>
                      <NewPasswordInput
                        change={this._handleFormChange}
                        name="password"
                        value={password}
                      />
                      <div className="yt-row space-between">
                        <div className="yt-col center">
                          <Link className="-forgot" to="/user/login"><em> Back To Login</em> </Link>
                        </div>
                        <button className="yt-btn primary" type="submit" disabled={isDisabled || submitting}>
                          { submitting ?
                            <span>Resetting...</span>
                            :
                            <span>Reset Password </span>
                          }
                        </button>
                      </div>
                    </form>
                    :
                    <form>
                      <h1 className="-form-header">Oops!</h1>
                      <p className="-form-sub-header">The password reset token is invalid or has expired. Please visit the forgot password page to request a new token.</p>
                      <br/>
                      <div className="input-group">
                        <Link to={"/user/forgot-password"} className="yt-btn primary block"><i className="fa fa-angle-double-left" /> Forgot Password </Link>
                      </div>
                    </form>
                  }
                </div>
              }
            </div>
            <div className="yt-col full s_50 m_60 l_60 -hero-container">
              <div className="-hero"></div>
            </div>
          </div>
          <AlertModal
            alertMessage={
              <div>
                <strong>
                  {this.state.errorMessage}
                </strong>
                <br/>
                <div>Please try again.</div>
              </div>
            }
            alertTitle="Error"
            closeAction={this._toggleErrorModal}
            confirmAction={this._toggleErrorModal}
            confirmText="Try again"
            isOpen={this.state.isErrorModalOpen}
            type="danger"
          />
        </div>
      </UserLoginLayout>
    )
  }
}

ResetPassword.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  return { user: store.user.loggedIn }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(ResetPassword)
);



// WEBPACK FOOTER //
// modules/user/views/ResetPassword.js.jsx